export enum HistoryActionTypes {
  GET_PORTFOLIO_HISTORY = 'GET_PORTFOLIO_HISTORY',
  GET_SCENARIO_HISTORY = 'GET_SCENARIO_HISTORY',
  GET_OPPORTUNITY_HISTORY = 'GET_OPPORTUNITY_HISTORY',
}
